import axios from 'axios'
import { useState, useEffect } from 'react';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit, AiOutlinePlus } from 'react-icons/ai';
import ToastNotification from '../../components/ToastNotification';
import { CiEdit } from "react-icons/ci";



const PartyMaster = () => {



  const [showForm, setShowForm] = useState(false);

  const [partyMaster, setPartyMaster] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  const [sources, setSources] = useState(["Online", "Store"]); // example
const [showSourceModal, setShowSourceModal] = useState(false);
const [newSourceName, setNewSourceName] = useState("");


  const [form, setForm] = useState({
    type: '',
    profession: '',
    type_profession: '',
    source: ''
  })

  const [searchTerm, setSearchTerm] = useState('');

  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };

  const handleAddClick = () => {
    setShowForm(true);
  };



  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();


    if (isEditMode) {
      const sendData = new FormData();

      sendData.append("type", form.type);
      sendData.append("profession", form.profession);
      sendData.append("type_profession", form.type_profession);
      sendData.append("source", form.source);


      try {
        const res = await axios.put(
          `https://api.skyguard.group/api/update-master-party/${form.id}`,
          sendData,
          { headers: { "Content-Type": "application/json", } }
        );


        showToast('Party Detail Added successfully!', 'success');
        setShowForm(false);
        fecthDetail();

        setForm({
          type: '',
          profession: '',
          type_profession: '',
          source: ''
        })
      } catch (err) {
        showToast('Fail to update party!', 'danger');
        console.error("❌ Error:", err.response?.data || err.message);
      }
    } else {
      const sendData = new FormData();

      sendData.append("type", form.type);
      sendData.append("profession", form.profession);
      sendData.append("type_profession", form.type_profession);
      sendData.append("source", form.source);


      try {
        const res = await axios.post(
          "https://api.skyguard.group/api/add-master-party",
          sendData,
          { headers: { "Content-Type": "application/json", } }
        );


        showToast('Party Detail Added successfully!', 'success');
        setShowForm(false);
        fecthDetail();

        setForm({
          type: '',
          profession: '',
          type_profession: '',
          source: ''
        })
      } catch (err) {
        showToast('Fail to add  party!', 'danger');
        console.error("❌ Error:", err.response?.data || err.message);
      }
    }



  };

  const fecthDetail = async () => {

    try {
      const resParty = await axios.get('https://api.skyguard.group/api/fetch-master-party');


      setPartyMaster(resParty.data.result);
    } catch (error) {
      console.log(error)
    }
  };

  useEffect(() => {

    fecthDetail();
  }, []);


  const handleDelete = async (id) => {


    try {
      await axios.delete(`https://api.skyguard.group/api/delete-master-party/${id}`);
      //   setRoles(roles.filter((role) => role.id !== id)); // remove from frontend list
      showToast("Party Detail deleted successfully");
      fecthDetail();

    } catch (err) {
      console.error("Error deleting role:", err);
      showToast("Failed to delete party detail");
      setTimeout(() => window.location.reload(), 2000);
    }
  };


  // const openModal = () => setShowModal(true);
  const openModal = (id) => {
    setSelectedId(id); // if you want to store it in state
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedId(null); // clear id when closing
  }


  const confirmDelete = () => {
    if (selectedId) {
    
      handleDelete(selectedId);
    }
    closeModal();
  };

  const handleEdit = (form) => {

    setForm({
      id: form.id || '',
      type: form.type || '',
      profession: form.profession || '',
      type_profession: form.type_profession || '',
      source: form.source || ''
    });
    setEditingCompanyId(form.id);
    setIsEditMode(true);
    setShowForm(true);
  };



  const filterParty = partyMaster.filter((tt) => {
    const term = searchTerm.toLowerCase();

    return (
      (tt.type && tt.type.toLowerCase().includes(term)) ||
      (tt.profession && tt.profession.toString().toLowerCase().includes(term)) || 
      (tt.type_profession && tt.type_profession.toString().toLowerCase().includes(term)) ||
      (tt.source && tt.source.toString().toLowerCase().includes(term))
    );
  });
  return (
    <div className='main-section'>
      <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
        <ToastNotification
          show={toast.show}
          message={toast.message}
          bg={toast.bg}
          onClose={() => setToast({ ...toast, show: false })}
        />
        <h3 className='my-3 fw-bold fs-5 golos'>Master of Party</h3>



        <div className="mb-3 d-flex flex-wrap align-items-end justify-content-between">

          <div className="mb-2 w-50 w-md-50 pe-md-2">
            <input
              className="form-control w-100"
              list="datalistOptions"
              placeholder="Search by Role,Department...."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <div className="mb-2">
            <button className="btn btn-success" onClick={handleAddClick}>
              <AiOutlinePlusCircle size={20} /> Add
            </button>
          </div>
        </div>


        {showForm && (


          <div className='card p-3 mb-3  w-75 mx-auto'>
            <form onSubmit={handleSubmit} >


                       {isEditMode && (
  <div className="mb-3">
    {/* <label>Company  Name:</label> <br /> */}
    <span className="badge bg-primary px-3 py-2">
     {form.type}
    </span>
  </div>
)}
              <hr />

              <div className='row g-3'>

                <div className="col-md-6">
                  <label htmlFor='name' className="form-label fw-medium" >Sector </label>
                  <input type="text" className="form-control" name="type" placeholder="Enter here..." value={form.type} onChange={handleInputChange} required />
                </div>

                <div className="col-md-6">
                  <label htmlFor='middle' className="form-label fw-medium" > Product Category </label>
                  <input type="text" className="form-control" name="profession" placeholder="Enter here..."
                    value={form.profession}
                    onChange={handleInputChange}

                  />
                </div>


                <div className="col-md-6">
                  <label htmlFor='middle' className="form-label fw-medium" >Type Of Profession</label>
                  <input type="text" className="form-control" name="type_profession" placeholder="Enter here..."
                    value={form.type_profession}
                    onChange={handleInputChange}

                  />
                </div>


                {/* <div className="col-md-6">
                  <label htmlFor='middle' className="form-label fw-medium" > Source</label>
                  <input type="text" className="form-control" name="source" placeholder="Enter here..."
                    value={form.source}
                    onChange={handleInputChange}

                  />
                </div> */}

                <div className="col-md-6">
  <label className="form-label fw-medium">Source</label>
  <select
    name="source"
    value={form.source}
    className="form-control"
    onChange={(e) => {
      if (e.target.value === "__add_new_source__") {
        setShowSourceModal(true);
      } else {
        handleInputChange(e);
      }
    }}
  >
    <option value="">-- Select --</option>

    {sources.map((src, i) => (
      <option key={i} value={src}>
        {src}
      </option>
    ))}

    <option value="__add_new_source__">➕ Add New Source</option>
  </select>
</div>


{showSourceModal && (
  <div className="modal show d-block" tabIndex="-1">
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Add New Source</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowSourceModal(false)}
          ></button>
        </div>

        <div className="modal-body">
          <input
            type="text"
            className="form-control"
            placeholder="Enter source name"
            value={newSourceName}
            onChange={(e) => setNewSourceName(e.target.value)}
          />
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => {
              setNewSourceName("");
              setShowSourceModal(false);
            }}
          >
            Cancel
          </button>

          <button
            type="button"
            className="btn btn-success"
            onClick={() => {
              if (!newSourceName.trim()) return;

              // Add to list
              setSources([...sources, newSourceName]);

              // Update form state
              handleInputChange({
                target: { name: "source", value: newSourceName }
              });

              // Reset
              setNewSourceName("");
              setShowSourceModal(false);
            }}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
)}


                <div className='gap-2 d-flex justify-content-center mt-4'>



                  <button type="submit" className='btn btn-success w-10'>
                    {isEditMode ? "Update" : "Save"}
                  </button>
                  <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                    setShowForm(false);
                    setIsEditMode(false);
                    setForm({
                      type: '',
                      profession: '',
                      type_profession: '',
                      source: ''
                    })
                  }}>
                    Cancel
                  </button>
                </div>

              </div>
            </form>
          </div>
        )}




        <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
          <table className='table table-bordered table-striped table-hover text-center align-middle'>

            <thead className='table-info'>
              <tr>
                   <th scope='col'>SN</th>
                    <th scope='col'>Action</th>
             
                <th scope='col'>Sector</th>
                <th scope='col'>Product Category</th>
                <th scope='col'>Type Of  Profession</th>
                <th scope='col'>Source</th>

            
              </tr>
            </thead>
            <tbody>
              {filterParty.map((acc, idx) => (
                <tr key={idx} >
                        <td>{idx + 1}</td>
                    <td>  <button
                    className="btn btn-success"
                    // onClick={() => handleDelete(acc.id)}
                    //  onClick={() => openModal(acc.id)}
                    onClick={() => handleEdit(acc)}
                  >
                    <CiEdit size={20} />
                  </button>
                  </td>

            
                  <td>
                    {acc.type}
                  </td>
                  <td> {acc.profession}  </td>
                  <td> {acc.type_profession}  </td>
                  <td> {acc.source}  </td>
                
                </tr>


              ))}
            </tbody>
          </table>
        </div>



        {showModal && (
          <div
            className="modal fade show"
            style={{
              display: "block",
              backgroundColor: "rgba(0,0,0,0.5)",
            }}
            tabIndex="-1"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Confirm Delete</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeModal}
                  ></button>
                </div>
                <div className="modal-body">
                  <p>
                    Are you sure you want to delete this detail :{" "}
                    {/* <strong>{selectedId}</strong>? */}
                  </p>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={closeModal}>
                    Cancel
                  </button>
                  <button className="btn btn-danger" onClick={confirmDelete}>
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default PartyMaster